import { useContext } from 'react';

import { LayoutContext } from '../../context';

const useLayout = () => useContext(LayoutContext);
export default useLayout;
